import { FillsGraphElement } from 'communication/types/fillsGraph/FillsGraphElement';
import { FillsGraphStreamElementType } from 'communication/types/fillsGraph/FillsGraphStreamElementType';
import { StreamElementType } from 'communication/types/StreamElementType';
import {
    StreamMessageElement,
    KeyedStreamElement,
    StreamDisableRangeElement,
} from 'communication/types/StreamElement';
import FillsGraphDataMessage from 'communication/types/fillsGraph/FillsGraphDataMessage';
import streamMessagesReducer, {
    omitStreamMessageTypeField,
} from 'utils/messages/StreamMessage';
import timeSeriesReducer from 'utils/timeseries/timeSeriesUtils';
import {
    FillsGraphDataState,
    FillsGraphStreamState,
    initialFillsGraphStreamState,
} from './FillsGraphDataState';
import {
    createStreamReducer,
    createProcessStreamDataMessage,
} from 'widgets/store/stream/reducer';
import {
    WidgetStreamMessagesState,
    WidgetStreamState,
} from 'widgets/store/stream/WidgetStreamState';
import { populateStrategyParametersStreamData } from 'widgets/strategyParams/store/stream/reducer';
import { StrategyParametersElement } from 'communication/types/strategyParams/StrategyParametersElement';
import disableRangeReducer from 'widgets/store/disableRange/StreamDisableRangeDataState';

export const processFillsGraphDataStreamElement = (
    element: FillsGraphElement,
    nextDataState: FillsGraphDataState,
    nextMessagesState: WidgetStreamMessagesState
) => {
    timeSeriesReducer(
        element as KeyedStreamElement<StreamElementType>,
        nextDataState
    );
    streamMessagesReducer(element as StreamMessageElement, nextMessagesState);
    disableRangeReducer(element as StreamDisableRangeElement, nextDataState);

    switch (element._c) {
        case StreamElementType.Msg: {
            /*
             * If the MSG["symbolPerm"] boolean field is set and is false,
             * this indicates a market data authorization failure
             * so in this case the ORDERSTAT state stored on the client is also cleared (and removed from the top legend).
             */
            if (element.symbolPerm === false) {
                nextDataState.snap = undefined;
            }
            break;
        }
        case StreamElementType.OrderStat: {
            nextDataState.orderStat = omitStreamMessageTypeField(element);
            break;
        }

        case FillsGraphStreamElementType.Snap: {
            nextDataState.snap = omitStreamMessageTypeField(element);
            break;
        }
        case FillsGraphStreamElementType.TotBuyFills: {
            nextDataState.totalBuyFills = omitStreamMessageTypeField(element);
            break;
        }
        case FillsGraphStreamElementType.TotSellFills: {
            nextDataState.totalSellFills = omitStreamMessageTypeField(element);
            break;
        }
        case FillsGraphStreamElementType.CostUpdate: {
            nextDataState.costUpdate = omitStreamMessageTypeField(element);
            break;
        }
        case FillsGraphStreamElementType.Vwap: {
            nextDataState.vwapUpdate = omitStreamMessageTypeField(element);
            break;
        }
        case FillsGraphStreamElementType.OrderOpen: {
            nextDataState.orderOpen = omitStreamMessageTypeField(element);
            break;
        }
        case FillsGraphStreamElementType.StrategyParams: {
            if (!nextDataState.strategyParams) {
                nextDataState.strategyParams = {
                    orderSelection: undefined,
                    paramGroups: [{}],
                };
            }

            populateStrategyParametersStreamData(
                omitStreamMessageTypeField(
                    element
                ) as StrategyParametersElement,
                nextDataState.strategyParams
            );
            break;
        }
    }
};

function handleStreamMessageReceive(
    element: FillsGraphElement,
    nextState: WidgetStreamState<FillsGraphDataState>
): FillsGraphStreamState {
    const nextDataState: FillsGraphDataState = nextState.data;
    processFillsGraphDataStreamElement(element, nextDataState, nextState);
    return nextState;
}

export const fillsGraphDataReducer = createStreamReducer<
    FillsGraphDataState,
    FillsGraphDataMessage
>(
    initialFillsGraphStreamState,
    createProcessStreamDataMessage(handleStreamMessageReceive)
);
